<script>
/*jshint esversion: 6 */
export default {
    name: "VtSortControl",
    props: ['props'],
    setup(props) {
        function getProps() {
            if (props && props.class) {
                const found = props.class.split(' ').findIndex((element) => element === 'fa-sort');
                if (found !== -1) {
                    return true;
                }
            }
        }
        return {
            getProps
        }
    }
}
</script>
<template lang="pug">
span.sortIconColor(v-if="props.sortable === true")  
    span(v-if="getProps() === true")
        span.chevronUp
            FontAwesomeIcon(icon="fa-solid fa-chevron-up")
        span.chevronDown
            FontAwesomeIcon(icon="fa-solid fa-chevron-down")
    span(v-else)
        FontAwesomeIcon(:icon="props.class")
</template>